import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../../Context/ThemeContext';

import FetchModule from '../../Share/Network/FetchModule';

import SalesPeriodView from './SalesPeriodView';
import { computeSalesPeriod } from './salesPeriodCompute';

export default function SalesPeriodBox(props) {
  const {
    startDate,
    endDate,
    settlementCycle,
    settlements,
    settledMerchantUids,
    yearSales,
    isOpenPartnerGymSales,
    setIsYearLoading
  } = props;

  const { isDark } = useTheme();
  const history = useHistory();

  const [monthData, setMonthData] = useState([]);
  const [periodSalesPrice, setPeriodSalesPrice] = useState(0);
  const [settlementPrice, setSettlementPrice] = useState(0);
  const [expectedSettlementPrice, setExpectedSettlementPrice] = useState(0);
  const [holidays, setHolidays] = useState(new Set());

  // 공휴일 데이터 조회 //
  useEffect(() => {
    const start = startDate.clone().subtract(10, 'days').format('YYYY-MM-DD');
    const end = endDate.clone().add(10, 'days').format('YYYY-MM-DD');

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('holiday?startDate=' + start + '&endDate=' + end, 'GET');

        if (responseData.status === 200) {
          const holidaySet = new Set();

          for (const holiday of responseData.data.holidays) {
            holidaySet.add(moment(holiday.holidayDate).format('YYYY-MM-DD'));
          }

          setHolidays(holidaySet);
        }
        else if (responseData.status === 401) {
          history.push('/');
        }
      }
    )();
  }, [startDate, endDate]);

  // 월별 매출 집계 + 기간 정산액 계산 (SalesPeriodBox / AI 공용 compute) //
  useEffect(() => {
    const result = computeSalesPeriod({ startDate, endDate, yearSales, settlements, settledMerchantUids, settlementCycle, holidays });

    setMonthData(result.monthData);
    setPeriodSalesPrice(result.periodSalesPrice);
    setSettlementPrice(result.settlementPrice);
    setExpectedSettlementPrice(result.expectedSettlementPrice);

    setTimeout(() => (
      setIsYearLoading(false)
    ), 1000)
  }, [startDate, endDate, yearSales, settlementCycle, settlements, settledMerchantUids, holidays])

  return (
    <TopLevelWrapper>
      <PeriodBox $isDark={isDark}>
        <SalesPeriodView
          startDate={startDate}
          endDate={endDate}
          monthData={monthData}
          periodSalesPrice={periodSalesPrice}
          settlementPrice={settlementPrice}
          expectedSettlementPrice={expectedSettlementPrice}
          isOpenPartnerGymSales={isOpenPartnerGymSales}
          showSettlement={true} />
      </PeriodBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const PeriodBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 20px 40px;
  margin-top: 20px;
  margin-bottom: 39.5px;

  width: calc(100% - 80px);
  min-height: 660px;

  gap: 15px;

  border-radius: 20px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: ${props => props.$isDark ? 'none' : '0px -20px 30px 0px rgba(0, 0, 0, 0.02)'};
`;
